import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
export const BlogCardSkeleton = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="sr-only">Loading blog content</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader><Skeleton className="h-5 w-3/4" /><Skeleton className="h-4 w-full mt-1" /><Skeleton className="h-4 w-2/3 mt-1" /></CardHeader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardContent><Skeleton className="h-48 w-full rounded-md" /></CardContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card className="flex flex-col h-full" aria-live="polite" aria-busy="true">{t0}{t1}{t2}<CardFooter className="flex flex-col items-start"><Skeleton className="h-4 w-32" /><Skeleton className="h-4 w-24 mt-2" /><Skeleton className="h-10 w-full mt-6 rounded-md" /></CardFooter></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};